import { createCache } from './cache';
const pendingCache = createCache();
const getPendingRequest = (key) => pendingCache.get(key);
const removePendingRequest = (key) => pendingCache.remove(key);
const setPendingRequest = (key, promise) => pendingCache.set(key, promise);
export const isPendingRequest = (key) => pendingCache.has(key);
export const withDedupe = (wrappedFetch) => async (input, options) => {
    const { dedupe, dedupeKey, ...restOptions } = options || {};
    if (dedupe && isPendingRequest(dedupeKey)) {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.log(`Reusing the response for "${dedupeKey}" from existing request.`);
        }
        const cachedResponse = await getPendingRequest(dedupeKey);
        if (cachedResponse.clone) {
            /**
             * We are cloning the response object as a workaround that makes reading Response body more than once possible.
             */
            return cachedResponse.clone();
        }
        return cachedResponse;
    }
    try {
        const pendingRequest = wrappedFetch(input, restOptions);
        if (dedupe) {
            setPendingRequest(dedupeKey, pendingRequest);
        }
        return await pendingRequest;
    }
    finally {
        if (dedupe && isPendingRequest(dedupeKey)) {
            removePendingRequest(dedupeKey);
        }
    }
};
//# sourceMappingURL=dedupe.js.map